import { createSlice } from "@reduxjs/toolkit";

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: { isExpanded: true },
  reducers: {
    toggle(state) {
      state.isExpanded = !state.isExpanded;
    },
  },
});

export const sidebarActions = sidebarSlice.actions;

export default sidebarSlice;
